<template>
  <div>
    <AppTabs
      :value="currentTab"
      :tabs="visibleTabs"
      @input="changedTab = $event"
    />
    <component
      :is="activeRequisiteComponentData.component"
      v-if="activeRequisiteComponentData"
      v-bind="activeRequisiteComponentData.props"
      @input="update"
    />
  </div>
</template>

<script>
import { provide } from '@vue/composition-api'
import { userHasAnyAllowedRole } from '@shared/permissions/validators'
import { mapGetters } from 'vuex'
// eslint-disable-next-line no-restricted-imports
import SimpleRequisites from '@cm/client/components/Requisites/SimpleRequisites'
// eslint-disable-next-line no-restricted-imports
import AdvanceRequisiteReadonly from '@cm/client/components/Requisites/AdvanceRequisiteReadonly'
// eslint-disable-next-line no-restricted-imports
import AdvanceRequisiteEditable from '@cm/client/components/Requisites/AdvanceRequisiteEditable'
// eslint-disable-next-line no-restricted-imports
import FreeformRequisites from '@cm/client/components/Requisites/FreeformRequisites'
import FormMixin from './FormMixin'

export default {
  mixins: [ FormMixin ],
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
    formId: {
      type: String,
      default: '',
    },
    formType: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      changedTab: null,
    }
  },
  setup (props) {
    provide('formValue', props.formValue)
  },
  computed: {
    ...mapGetters([ 'user' ]),
    activeRequisiteComponentData () {
      const disabled = this.disabled || !userHasAnyAllowedRole(this.user, null, this.currentTab.rolesAllowedToEdit)
      switch (this.currentTab.key) {
        case 'requisitesSimple':
          return {
            component: SimpleRequisites,
            props: {
              value: this.value?.requisitesSimple,
              formValue: this.formValue,
              parentValue: this.value,
              formId: this.formId,
              formType: this.formType,
              config: this.config,
              disabled,
            },
          }
        case 'requisitesFreeform':
          return {
            component: FreeformRequisites,
            props: {
              value: this.value?.requisitesFreeform,
              parentValue: this.value,
              config: this.config,
              disabled,
            },
          }
        case 'requisitesAdvanced':
          return {
            component: disabled
              ? AdvanceRequisiteReadonly
              : AdvanceRequisiteEditable,
            props: {
              value: this.value?.requisitesAdvanced,
              parentValue: this.value,
              config: this.config,
            },
          }
        default:
          console.error('Unknown tab')
          return null
      }
    },
    visibleTabs () {
      return Object.values(this.config.fields || {}).filter(tab => userHasAnyAllowedRole(this.user, null, tab.rolesAllowedToSee))
    },
    currentTab () {
      return this.changedTab || this.visibleTabs[0] || {}
    },
  },
  methods: {
    update (value) {
      this.$emit('input', { ...(this.value || {}), [this.currentTab.key]: value })
    },
  },
}
</script>
